import React from 'react';
import './Reviews.css';
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";

import avatar_img from '../assets/icons/avatar.svg';
import GlassyButton from "./GlassyButton";


export const reviews = [
    {
        name: "Алексей",
        rating: 5,
        text: "Менял крупную сумму наличными, всё прошло спокойно и без лишних вопросов. Договорились о времени в чате, встретились в офисе, всё чётко и прозрачно."
    },
    {
        name: "Игорь",
        rating: 5,
        text: "Хороший обменник в Перми. Курс нормальный, сотрудники вежливые. Особенно понравилось, что встреча проходит в офисе, а не где-то на улице."
    },
    {
        name: "Дмитрий",
        rating: 5,
        text: "Обменял USDT на рубли, получил наличку быстро и без проблем. Всё организовано удобно и безопасно."
    },
    {
        name: "Сергей",
        rating: 5,
        text: "Удобный процесс: написал в Telegram, договорились о сумме и времени, в офисе всё прошло за несколько минут. Остался доволен."
    },
    {
        name: "Антон",
        rating: 5,
        text: "Работают честно и надёжно. Курс соответствует договорённому, никаких скрытых комиссий. Буду пользоваться дальше."
    }
];


const handleClick = () => {
    const username = "obmenvpermi";
    const url = `https://t.me/${username}`;

    window.location.href = url;

    if (window.Telegram?.WebApp?.openTelegramLink) {
        window.Telegram.WebApp.openTelegramLink(url);
    }
};


const Reviews = () => {
    const [emblaRef] = useEmblaCarousel(
        { loop: true, align: "start" },
        [Autoplay({ delay: 5000, stopOnInteraction: true })]
    );

    return (
        <div className="reviews-wrapper card">
            <h2 className="uppercase" style={{ marginTop: "2px", marginBottom: "-2px" }}>
                Отзывы клиентов
            </h2>

            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {reviews.map((r, i) => (
                        <div className="embla__slide" key={i}>

                            <div className="review-card">

                                <div className={'review-card-top'}>

                                    <div className={'review-card-ava-container'}>
                                        <img className={'review-card-ava'} src={avatar_img} alt={r.name}/>
                                    </div>

                                    <div className={'review-card-top-right'}>

                                        <h4>{r.name}</h4>

                                        <p className={'review-card-stars'}>{"⭐".repeat(r.rating)}</p>

                                    </div>

                                </div>

                                <p>{r.text}</p>
                            </div>

                        </div>
                    ))}
                </div>
            </div>


            <GlassyButton onClick={() => handleClick()} className={'full'}>
                Оставить отзыв
            </GlassyButton>

        </div>
    );
};

export default Reviews;